import { createContext, memo, ReactNode, useContext, useState } from "react";
import { useWatchStream } from "../hooks/use-watch-stream";
import { RedoOutboundLabelsRpcClientContext } from "../outbound-labels-rpc-client";
import { useStreamingEnabled } from "./streaming-enabled-context";

export interface LiveOmsSettingsValue {
  isRedoConnectDisabled: boolean;
}

export const LiveOmsSettingsContext = createContext<LiveOmsSettingsValue>({
  isRedoConnectDisabled: false,
});

export const LiveOmsSettingsProvider = memo(function LiveOmsSettingsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isRedoConnectDisabled, setIsRedoConnectDisabled] = useState(false);
  const client = useContext(RedoOutboundLabelsRpcClientContext);
  const streamingEnabled = useStreamingEnabled();

  useWatchStream(
    streamingEnabled ? client : undefined,
    "watchOmsSettings",
    {},
    ({ isRedoConnectDisabled }) => {
      setIsRedoConnectDisabled(isRedoConnectDisabled);
    },
    true,
  );

  return (
    <LiveOmsSettingsContext.Provider value={{ isRedoConnectDisabled }}>
      {children}
    </LiveOmsSettingsContext.Provider>
  );
});
